// extracted by mini-css-extract-plugin
export default {"tagContainer":"aokpWRXkWZiuTn55CRdR","contentText":"N2_QvkJ0i60NA5Jnp658","verticalAlignTextBottom":"xq8E9VCMKdmMJrCWgMKV"};